module.exports = __webpack_public_path__ + "static/media/pink_badge.4e1444db.svg";